import Inventories from "../../../views/Inventories";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const InventoriesRoutes = [
  {
    menuName: MenuNames.SPIN_THE_WHEEL,
    path: "/inventories",
    component: Inventories,
    exact: true,
  },
];

export default InventoriesRoutes;
